<div
    #shadow
    class="agpr-twigRenderer"
    [id]="id"
    [attr.tabindex]="preventChildFocus ? -1 : null"
></div>
@if (generateOnSend && hasInitted) {
    <div class="agpr-twigRenderer-watermark">
        {{ 'Reports.chart.dataSendTime' | localize }}
    </div>
}
@if (renderedBackup) {
    <div
        class="agpr-twigRenderer"
        [innerHTML]="renderedBackup"
    ></div>
}
